import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import {
  BulkContactAssignmentProjectDocument,
  BulkContactAssignmentProjectMutation,
  ContactFragment,
  ContactsDetailsPageRouteDocument,
  ProjectsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'

import { ContactProjectListPermissions } from 'modules/finance/hooks/useContactProjectListPermissions'
import ProjectsDataCollection from 'modules/project_management/components/tables/ProjectsDataCollection'

import ContactsAddProjectsModal from './ContactsAddProjectsModal'
import { CreateWizard } from './CreateWizard'

type Props = {
  contact: ContactFragment
  policies: ContactProjectListPermissions['policies']
}

const ContactsProjectsList = ({ contact, policies }: Props) => {
  const { company } = useCurrentSession()
  const [showAddProjects, setShowAddProjects] = useState(false)
  const [showLinkProjects, setShowLinkProjects] = useState(false)

  const [manage] = useMutation(BulkContactAssignmentProjectDocument, {
    extractorFn: (data: BulkContactAssignmentProjectMutation) =>
      data.projectManagementMutations.bulkClientAssignmentProjectmanagementProject,
  })

  const removeProjects = async (projectIds: number[]) => {
    await manage({
      variables: {
        companyId: company.id,
        projectIds: projectIds,
      },
      awaitRefetchQueries: true,
      refetchQueries: [ProjectsDataCollectionDocument, ContactsDetailsPageRouteDocument],
    })
  }

  const handleOnClickLinkProject = () => {
    setShowLinkProjects(true)
  }

  const handleOnClickCreateProject = () => {
    setShowAddProjects(true)
  }

  const handleOnClickUnlinkProject = (projectIds: number[]) => {
    removeProjects(projectIds)
  }

  return (
    <Box paddingTop="s24">
      <>
        <ProjectsDataCollection
          canSeeCosts={policies.canSeeCosts}
          clientId={contact.id}
          canCreateProjects={policies.canCreateProjects}
          canManageProjects={policies.canManageProjects}
          hasClientsFeature
          hasCostsFeature={policies.hasCostsFeature}
          hasExpensesFeature={policies.hasExpenses}
          onClickCreateClientProject={handleOnClickCreateProject}
          onClickLinkClientProject={handleOnClickLinkProject}
          onClickUnlinkProject={handleOnClickUnlinkProject}
        />
        {showLinkProjects && (
          <ContactsAddProjectsModal
            onClose={() => setShowLinkProjects(false)}
            clientId={contact.id}
          />
        )}
        {showAddProjects && (
          <CreateWizard
            client={contact}
            onClose={() => {
              setShowAddProjects(false)
            }}
            onSuccess={() => {
              setShowAddProjects(false)
            }}
          />
        )}
      </>
    </Box>
  )
}

export default ContactsProjectsList
